var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F7A91C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9382 23.9475C29.8616 23.825 29.7274 23.75 29.5832 23.75H10.4166C10.2724 23.75 10.1383 23.825 10.0624 23.9475C9.98659 24.07 9.97909 24.2233 10.0441 24.3525C10.6291 25.5233 11.8049 26.25 13.1132 26.25H26.8866C28.1941 26.25 29.3699 25.5233 29.9566 24.3533C30.0199 24.2233 30.0141 24.0708 29.9382 23.9475Z",
    fill: "#F7A91C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1438 15.5033C21.2121 15.3491 21.2512 15.1791 21.2512 15C21.2512 14.3108 20.6904 13.75 20.0013 13.75C19.3121 13.75 18.7512 14.3108 18.7512 15C18.7512 15.1792 18.7904 15.3492 18.8587 15.5033C15.0829 16.0225 12.1012 19.0625 11.7188 22.9167H28.2829C27.9004 19.0642 24.9179 16.0225 21.1438 15.5033ZM19.6121 17.9158C17.2812 18.07 15.2737 19.5916 14.4996 21.7925C14.4396 21.9633 14.2779 22.0708 14.1063 22.0708C14.0604 22.0708 14.0137 22.0633 13.9679 22.0475C13.7513 21.9708 13.6371 21.7333 13.7129 21.5158C14.5979 18.9991 16.8921 17.26 19.5571 17.0841C19.7779 17.07 19.9846 17.2425 20.0004 17.4725C20.0154 17.7025 19.8421 17.9008 19.6121 17.9158Z",
    fill: "#F7A91C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.0884395450ecedfd5c2c0766d2576504.svg";
export { ForwardRef as ReactComponent };